import React from 'react';

const offerings = [
  {
    num: '01',
    title: 'High-Converting Website',
    desc: 'A website built to generate calls and bookings — not just look pretty.',
    features: [
      'Built to generate calls & bookings',
      'Fast, modern, mobile-first',
      'Clear conversion funnel',
      'SEO optimized',
    ],
    accent: false,
  },
  {
    num: '02',
    title: 'AI Automation System',
    desc: 'An AI layer that responds, qualifies, books, and follows up — automatically.',
    features: [
      'Instant lead response (AI chat / SMS)',
      'Auto follow-ups — no lost leads',
      'Booking automation',
      'Lead qualification',
    ],
    accent: true,
  },
];

export default function Services() {
  return (
    <section id="services" className="py-32 px-6 w-full" style={{ background: '#082318' }}>
      <div className="max-w-[1100px] mx-auto">
        <div className="mb-16 text-center">
          <p className="text-xs font-mono uppercase tracking-widest mb-4 font-semibold" style={{ color: '#d4f542' }}>The Solution</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white tracking-tight mb-5 leading-tight">
            We Turn Your Website Into a<br />Smart Sales System
          </h2>
          <p className="text-base md:text-lg max-w-xl mx-auto italic" style={{ color: 'rgba(255,255,255,0.5)' }}>
            "Your business responds instantly — even when you're offline."
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {offerings.map((s, i) => (
            <div
              key={i}
              className="p-10 rounded-2xl flex flex-col relative overflow-hidden"
              style={{
                background: s.accent ? '#0e3322' : '#0c2d1e',
                border: s.accent ? '1px solid rgba(212,245,66,0.25)' : '1px solid rgba(255,255,255,0.07)',
              }}
            >
              {s.accent && (
                <div
                  className="absolute -top-12 -right-12 w-48 h-48 rounded-full pointer-events-none"
                  style={{ background: 'radial-gradient(circle, rgba(212,245,66,0.08) 0%, transparent 70%)' }}
                />
              )}
              <span className="text-sm font-mono mb-5 block font-bold" style={{ color: '#d4f542' }}>{s.num}</span>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-tight">{s.title}</h3>
              <p className="text-base leading-relaxed flex-grow mb-8" style={{ color: 'rgba(255,255,255,0.55)' }}>{s.desc}</p>
              <ul className="space-y-3" style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: '1.5rem' }}>
                {s.features.map((f, j) => (
                  <li key={j} className="flex items-center gap-3 text-sm font-medium" style={{ color: 'rgba(255,255,255,0.7)' }}>
                    <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: '#d4f542' }} />
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

